var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconContact03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 133,
    viewBox: "0 0 138 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dot",
    clipPath: "url(#clip0_885_31236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M131.12 21.2005C134.08 21.2005 136.48 18.8007 136.48 15.8405C136.48 12.8802 134.08 10.4805 131.12 10.4805C128.16 10.4805 125.76 12.8802 125.76 15.8405C125.76 18.8007 128.16 21.2005 131.12 21.2005Z",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.77003 113.208C9.73028 113.208 12.13 110.809 12.13 107.848C12.13 104.888 9.73028 102.488 6.77003 102.488C3.80979 102.488 1.41003 104.888 1.41003 107.848C1.41003 110.809 3.80979 113.208 6.77003 113.208Z",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M99.51 68.6797C102.25 68.6797 102.25 64.4297 99.51 64.4297C96.77 64.4297 96.77 68.6797 99.51 68.6797Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M125.76 109.09C128.5 109.09 128.5 104.84 125.76 104.84C123.02 104.84 123.02 109.09 125.76 109.09Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M78.94 124.32C81.68 124.32 81.68 120.07 78.94 120.07C76.2 120.07 76.2 124.32 78.94 124.32Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M89.02 75.0703C91.76 75.0703 91.76 70.8203 89.02 70.8203C86.28 70.8203 86.28 75.0703 89.02 75.0703Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M18.17 33.2109C20.91 33.2109 20.91 28.9609 18.17 28.9609C15.43 28.9609 15.43 33.2109 18.17 33.2109Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M55.82 132.238C58.56 132.238 58.56 127.988 55.82 127.988C53.08 127.988 53.08 132.238 55.82 132.238Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M99.51 82.9395C97.17 97.3595 89.86 107.64 76.71 112.77C59.91 119.32 43.57 117.2 29.18 106.45C18.19 98.2395 12.57 86.6095 12.14 72.5895C11.87 63.6795 14.29 55.6595 18.4 48.2695C20.42 53.2795 22.11 58.4395 24.52 63.2495C28.13 70.4595 33.6 76.2395 40.22 80.8295C42.63 82.4995 43.33 84.4795 42.61 87.1995C42.01 89.4995 41.34 91.8095 41.1 94.1495C40.98 95.3395 41.39 96.9995 42.2 97.7395C42.76 98.2495 44.6 97.8495 45.56 97.3095C48.07 95.9195 50.54 94.3995 52.79 92.6295C56.14 89.9995 59.62 89.3895 63.85 90.0895C76.11 92.1195 87.7 90.0195 98.33 83.3395C98.56 83.1995 98.85 83.1495 99.5 82.9295L99.51 82.9395Z",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M107.75 22.8789C92.7001 19.1089 78.2701 19.4089 64.6301 28.0189C51.1501 36.5289 43.3101 48.5889 40.0101 64.1989C39.5601 63.9089 39.0001 63.7289 38.7001 63.3389C33.2601 56.1689 30.0001 48.0189 30.2401 39.0889C30.6401 24.2089 38.2001 13.3289 51.2601 6.61893C68.4401 -2.19107 86.1601 0.298928 100.57 13.2089C103.47 15.8089 105.74 19.0889 108.31 22.0589C108.13 22.3289 107.94 22.5989 107.76 22.8689L107.75 22.8789Z",
    stroke: "black",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M100.39 111.201C122.74 82.2613 109.92 44.4013 78.9301 33.4113C84.6801 31.2413 90.3101 30.8613 95.9701 31.1813C112.61 32.1513 126.89 44.0213 130.1 60.2613C133.34 76.6413 128.75 90.7913 116.46 102.351C112.01 106.531 106.69 108.961 100.38 111.201H100.39Z",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_885_31236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 137.89,
    height: 132.24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContact03);
export default __webpack_public_path__ + "static/media/icon_contact_03.2080d03df15245ddb6a26120b2ad906f.svg";
export { ForwardRef as ReactComponent };